import { useTranslations } from "@zapier/i18n";
import { Icon } from "@zapier/zinnia-icons";
import {
  BetaDataTableCell as Cell,
  Spacer,
  Text,
  Tooltip,
  TooltipFocusableTrigger,
} from "@zapier/design-system";

import styles from "./CheckAppConnectionCell.module.css";

interface CheckAppConnectionCellProps {
  isStale: boolean;
}

const CheckAppConnectionCell = ({ isStale }: CheckAppConnectionCellProps) => {
  const t = useTranslations("connections-table-status-cell");

  return (
    <Cell className={styles.cell}>
      <div className={styles.root}>
        {isStale ? (
          <>
            <Tooltip
              content={t("status.expired-connections")}
              placement="bottom"
            >
              <TooltipFocusableTrigger>
                <Icon
                  color="StatusErrorStronger"
                  name="formXCircle"
                  size="24"
                />
              </TooltipFocusableTrigger>
            </Tooltip>
            <Text type="Body1">{t("status.expired-connections")}</Text>
          </>
        ) : (
          <Spacer width={88} />
        )}
      </div>
    </Cell>
  );
};

export default CheckAppConnectionCell;
